/**
 * useMessagingPrefs — 149-cc.
 * Shared hook: load messaging preferences (notif, sound, dnd) dari server so
 * they sinkron lintas device. Emit `ens:msgprefs` event ketika berubah supaya
 * MessengerFAB/Drawer + ProfileDialog otomatis update tanpa reload.
 */
import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULTS = { notif: true, sound: true, dnd: false, effective_sound: true };
let cache = null;

export default function useMessagingPrefs(enabled = true) {
  const [prefs, setPrefs] = useState(cache || DEFAULTS);
  const [loaded, setLoaded] = useState(!!cache);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/messaging/prefs");
      cache = { ...DEFAULTS, ...data };
      setPrefs(cache);
      setLoaded(true);
      window.dispatchEvent(new CustomEvent("ens:msgprefs", { detail: cache }));
    } catch { setLoaded(true); }
  }, []);

  useEffect(() => {
    if (!enabled) return;
    if (!cache) refresh();
    const on = (e) => setPrefs(e.detail || DEFAULTS);
    window.addEventListener("ens:msgprefs", on);
    return () => window.removeEventListener("ens:msgprefs", on);
  }, [enabled, refresh]);

  const update = useCallback(async (patch) => {
    const prev = cache || DEFAULTS;
    const optimistic = { ...prev, ...patch };
    cache = optimistic; setPrefs(optimistic);
    window.dispatchEvent(new CustomEvent("ens:msgprefs", { detail: optimistic }));
    try {
      const { data } = await api.patch("/messaging/prefs", patch);
      cache = { ...DEFAULTS, ...data };
      setPrefs(cache);
      window.dispatchEvent(new CustomEvent("ens:msgprefs", { detail: cache }));
      return cache;
    } catch (e) {
      cache = prev; setPrefs(prev);
      window.dispatchEvent(new CustomEvent("ens:msgprefs", { detail: prev }));
      throw e;
    }
  }, []);

  return { prefs, loaded, update, refresh };
}
